enum TYPE_COURRIER {
  RAPPORT_POST_ROP = "Rapport post ROP",
}

export default TYPE_COURRIER;
